import { Insta } from "../../src/components/insta/InstaClass";
import { Phone, PHONE_BUTTONS } from "../../src/components/phoneUI/PhoneClass";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import UI from "../../src/shell/UI";
import { jump } from "../../src/shell/jump";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { PhoneStyle } from "../../src/store/slices/phoneSlice";
import { store } from "../../src/store/store";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { hobo } from "../characters/Hobo";
import { mc } from "../characters/MC";
import { player1 } from "../characters/Player1";
import { stranger } from "../characters/Stranger";
import { annImages } from "../helpers/annInstaImages";
import { doTakePhoto, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { extras, images, uiImages } from "./images";
import { V7AnnPhotoShootAfter } from "./V7";
import { endReplay } from "../../src/shell/endReplay";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";



export const V7AnnPhotoShoot = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V7VanessaMorningAfter`)) {
        doTransition(images.v7.V7AnnMCRoom_38);
        ann.talk(`I'm glad you agreed to meet! I wanted to talk to you about something.`);
        mc.talk(`Sure, what about?`);

    } else {
        ImageClass.setImage(images.v7.V7AnnMCRoom_42, { transition: true, duration: 1 });
        ann.talk(`Good morning!`);
        mc.talk(`Woah, Ann. What are you doing here?`);
        ann.talk(`Not happy to see me?`);
        mc.talk(`I am!`);
        ann.talk(`Hehe, I missed you so I figured I'd drop by. I hope it's ok.`);
        mc.talk(`Of course.`);
        mc.talk(`Sec, let me get up.`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_38, { duration: 1 });
        ann.talk(`By the way, I spoke with your ${emily.properties.relation} on my way in.`);
        if (Question.globalAnswers.v5TouchedAnnInLivingRoom) {
            ImageClass.setImage(images.v7.V7AnnMCRoom_39);
            ann.talk(`I was scared she wouldn't like me after that little incident we had in the living room the other day.`);
            ann.talk(`But she was really nice!`);
            mc.talk(`I told you not to worry.`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38);
            ann.talk(`I am glad you were right!`);

        } else {
            ann.talk(`She is so nice!`);
            mc.talk(`Yeah she is.`);

        }
        mc.talk(`How are you feeling after yesterday?`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_39);
        ann.talk(`Yeah... About yesterday, hehe.`);
        ann.talk(`It was so wild... But can we talk about that later? Right now I really need your help with something.`);
        mc.talk(`Of course, what is it?`);
    }

    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`First things first. Remember the audition I was supposed to go to?`);

    if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor !== undefined) {
        ImageClass.setImage(images.v7.V7AnnMCRoom_38);
        mc.talk(`Wait, hold on!`);
        mc.talk(`Aren't we going to talk about what happened with Joey?`);

        if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {
            ImageClass.setImage(images.v7.V7AnnMCRoom_39);
            ann.talk(`Hehe, talk about what?`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38);
            mc.think(`Vanessa told me she sorted everything out...`);
            mc.think(`But I'm not sure Ann knows all the details...`);
            mc.talk(`What do you know exactly?`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_39);
            ann.talk(`I know that I was supposed to act like I didn't know it was Joey until you rushed in and stopped it.`);
            mc.talk(`But I didn't...`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38.partials.V7AnnMCRoom_38_p);
            ann.talk(`Hehe, I know...`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_39);
            ann.talk(`I figured that you might prefer not to stop it...`);
            ann.talk(`So I just went with it... For you.`);
            mc.talk(`And wasn't it weird?`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38.partials.V7AnnMCRoom_38_p_2);
            ann.talk(`A bit... But I knew you'd enjoy it, that's all I was focused on.`);

        } else {
            ImageClass.setImage(images.v7.V7AnnMCRoom_38.partials.V7AnnMCRoom_38_p_2);
            ann.talk(`Didn't Vanessa tell you?`);
            ann.talk(`It was all an act!`);
            ann.talk(`Vanessa set everything up.`);
            ann.talk(`She told me that I should act surprised once you stopped Joey.`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38);
            mc.talk(`But what if I didn't?`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_39);
            ann.talk(`I never thought about that as an option...`);
            ann.talk(`I just knew you'd storm in and that's it.`);
            mc.talk(`I must say. You were really convincing.`);
            ImageClass.setImage(images.v7.V7AnnMCRoom_38.partials.V7AnnMCRoom_38_p_2);
            ann.talk(`Hehe, thank you.`);
        }

        ImageClass.setImage(images.v7.V7AnnMCRoom_38);
        mc.talk(`Now we can get back to talk about your audition.`);
        mc.talk(`Why did you talk about the audition in past tense, have you changed your mind?`);

    } else {
        ImageClass.setImage(images.v7.V7AnnMCRoom_38);
        mc.talk(`Supposed? Have you changed your mind?`);
    }


    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Hehe, no. It got postponed to tomorrow so I figured I could do something productive today.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`Like what?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`I was thinking that I can't be a good actress without a good Insta.`);
    ann.talk(`And this is where you come in.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`I need your help taking a few pictures of me.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Please!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`Sure.`);
    mc.think(`She is really committing to this it seems.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Great! I've talked to Alex and she took a quick photo at her place.`);
    ann.talk(`But I don't want to leech on her, she has her own Insta to take care of.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`I understand.`);
    mc.talk(`What kind of pictures do you have in mind?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Hehe... You know... The kind of pictures that will get me some nice amount of likes. Alex gave me some tips so I have a good idea.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`Are you sure that's the kind of photos you wanna upload?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Positive!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`Well, the timing couldn't be any better.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_39);
    ann.talk(`Why is that?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_38);
    mc.talk(`Check the bag over there.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_40);
    ann.talk(`Oh wow I didn't even notice that.`);
    ann.talk(`What's in there?`);
    mc.talk(`A little something for you. Go ahead and take a look.`);


    return jump(V7AnnAtMCRoom2, "V7AnnAtMCRoom2");
};

export const V7AnnAtMCRoom2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_0, { duration: 0.6 });
    ann.talk(`I'm so curious!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_1);
    ann.talk(`What's this?`);
    mc.talk(`It's a gift for you.`);
    ann.talk(`For me? How did you get it?`);
    mc.talk(`That's not important.\nDo you like it?`);
    ann.talk(`I don't know... I guess I need to try it on.`);
    mc.talk(`Go ahead.`);
    ann.talk(`Now?`);
    mc.talk(`Sure, why not?`);
    ann.talk(`I guess...\nGive me a second.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_2, { duration: 0.6 });
    ann.talk(`I'm curious how you got this.`);
    ann.talk(`I bet Vanessa was involved.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_3, { duration: 0.6 });
    ann.talk(`How do you even wear this thing?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_4, { duration: 0.6 });
    ann.talk(`Oh, I see.`);
    mc.talk(`I like the view.`);
    ann.talk(`Stop it! Hehe.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_6, { duration: 0.6 });
    ann.talk(`Done!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_5, { duration: 0.6 });
    ann.talk(`So?`);
    mc.talk(`You don't look pleased.`);
    ann.talk(`Because I don't know how you feel about it.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_8);
    mc.talk(`I like it...a lot.`);
    ann.talk(`Are you sure?`);
    mc.talk(`Yes, you look hot.`);
    ann.talk(`Hehe, thanks.`);
    ann.talk(`I won't lie... I feel sexy in this.`);
    ann.talk(`But I don't know if it's a good idea to post it on my new Insta?`);
    mc.talk(`I bet it will help you gain tons of followers real quick...`);
    ann.talk(`I can't argue with that...`);
    mc.talk(`Let me take some photos of you and later you'll decided if you wanna post them or not.`);
    ann.talk(`That's sounds fair.`);

    return jump(V7AnnAtMCRoom2_Question, "V7AnnAtMCRoom2_Question");
};

export const V7AnnAtMCRoom2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_8);
    await ann.setQuestion(new Question({ text: `It's a deal!`, options: { think: false }, key: `v7PhotoShootRoomTouchedAnn` })
        .option({ title: `Start touching her`, key: true })
        .option({ title: `Continue talking`, key: false }));


    if (Question.globalAnswers.v7PhotoShootRoomTouchedAnn) {

        return jump(V7AnnAtMCRoom2_Question_Touch, "V7AnnAtMCRoom2_Question_Touch");
    } else {

        return jump(V7AnnAtMCRoom_PhotoShoot, "V7AnnAtMCRoom_PhotoShoot");
    }

};

export const V7AnnAtMCRoom2_Question_Touch = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_9, { duration: 0.6 });
    await mc.set((properties) => {
        properties.annRelationship++;
    });
    mc.talk(`You know... This outfit really turns me on.`);
    ann.talk(`Does it?`);
    mc.talk(`A lot.`);
    return jump(V7AnnAtMCRoom2_Question_Touch_Question, "V7AnnAtMCRoom2_Question_Touch_Question");
};

export const V7AnnAtMCRoom2_Question_Touch_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_9);
    await ann.setQuestion(new Question({ text: `Oh...`, options: { think: false }, key: `v7PhotoShootRoomFuckedAnn` })
        .option({ title: `Fuck her`, key: true })
        .option({ title: `Let go`, key: false }));


    if (Question.globalAnswers.v7PhotoShootRoomFuckedAnn) {
        return jump(V7AnnAtMCRoom2_Question_Touch_Question_Fuck, "V7AnnAtMCRoom2_Question_Touch_Question_Fuck");

    } else {
        return jump(V7AnnAtMCRoom2_Question_Touch_Question_LetGo, "V7AnnAtMCRoom2_Question_Touch_Question_LetGo");

    }
};


export const V7AnnAtMCRoom2_Question_Touch_Question_Fuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_9);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.talk(`You've turned me on so bad I wanna fuck you now.`);
    mc.talk(`Get down on your knees.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_10);
    mc.talk(`You've done it before.`);
    ann.talk(`...`);
    ImageClass.setImage(images.v7.Anim_V7AnnMCRoomBlowjob.poster, { duration: 0.6 });
    mc.talk(`Ah... Yeah...`);

    ImageClass.setAnimation(images.v7.Anim_V7AnnMCRoomBlowjob);
    mc.talk(`That's good. Keep going.`);
    ann.talk(`Mhmmm.`);
    mc.talk(`Ah...`);
    ann.talk(`Ghup. Slwuup. Swurrp.`);
    mc.think(`Damn she is getting much better at this. Need to move this along or I won't last long.`);
    mc.talk(`Here. Lean on the table... I want to fuck you.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_13, { transition: true });
    mc.talk(`Damn, this position is something else.`);
    mc.think(`I never thought I'd use this desk for more than playing video games.`);
    ImageClass.setImage(images.v7.Anim_V7AnnMCRoomVaginal.poster, { duration: 0.6 });
    ann.talk(`Ah...`);
    mc.talk(`Mhhhmmm... Ann seems you are just as ready as I am... `);
    ImageClass.setAnimation(images.v7.Anim_V7AnnMCRoomVaginal);

    mc.think(`She is still so tight. I can feel her clamping down already.`);
    ann.talk(`Ahh... ${mc.name}... This feels sooo gooood!`);
    mc.talk(`Yes it does Sweet Ann... Mmmhhhh.`);
    ann.talk(`Don't stop please!`);
    return jump(V7AnnAtMCRoom2_Question_Fuck_Question, "V7AnnAtMCRoom2_Question_Fuck_Question");
};

export const V7AnnAtMCRoom2_Question_Fuck_Question = async (): Promise<any> => {
    await mc.setQuestion(new Question({ text: `I wonder...`, options: { think: true }, key: `v7PhotoShootRoomStuckFingerInAnnAss` })
        .option({ title: `Stick a finger in her ass`, key: true })
        .option({ title: `Just keep fucking her`, key: false }));


    if (Question.globalAnswers.v7PhotoShootRoomStuckFingerInAnnAss) {
        return jump(V7AnnAtMCRoom2_Question_Fuck_Question_Finger, "V7AnnAtMCRoom2_Question_Fuck_Question_Finger");

    } else {
        return jump(V7AnnAtMCRoom2_Question_Fuck_Question_Normal, "V7AnnAtMCRoom2_Question_Fuck_Question_Normal");

    }
};

export const V7AnnAtMCRoom2_Question_Fuck_Question_Finger = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_16, { duration: 0.6 });
    await ann.set((properties) => {
        properties.corruption++;
    });
    ann.talk(`Ah!`);
    ann.talk(`Ooohhh yesss! Khhhaaa...`);
    mc.think(`That was a first for her for sure.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_18);
    mc.think(`Good lord! I'm almost there!`);
    ann.talk(`${mc.name}! I'm...`);
    mc.talk(`Me too!`);
    mc.talk(`AHH!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_20, { wait: 0.4 });
    ImageClass.setImage(images.v7.V7AnnMCRoom_19, { duration: 1 });
    mc.think(`God. That was good. I can't get enough of this girl.`);

    return jump(V7AnnAtMCRoom2_Question_Fuck_Continue, "V7AnnAtMCRoom2_Question_Fuck_Continue");
};

export const V7AnnAtMCRoom2_Question_Fuck_Question_Normal = async (): Promise<any> => {
    ann.talk(`Ohhhh ${mc.name}!`);
    mc.talk(`I'm cumming!!`);
    mc.talk(`AHH!`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_20, { wait: 0.4 });
    ImageClass.setImage(images.v7.V7AnnMCRoom_19, { duration: 1 });
    mc.think(`God. That was good. I can't get enough of this girl.`);

    return jump(V7AnnAtMCRoom2_Question_Fuck_Continue, "V7AnnAtMCRoom2_Question_Fuck_Continue");
};

export const V7AnnAtMCRoom2_Question_Fuck_Continue = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_30, { duration: 0.6 });
    ann.talk(`Wow.`);
    if (Question.globalAnswers.v7PhotoShootRoomStuckFingerInAnnAss) {
        ImageClass.setImage(images.v7.V7AnnMCRoom_31);
        ann.talk(`That was different...`);
        ann.talk(`I didn't expect that...`);
        mc.talk(`But, did you enjoy it?`);
        ann.talk(`Mmm...`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_32);
        ann.talk(`It was different for sure... Hehe, I can't say it was bad.`);
        mc.talk(`So you did enjoy it.`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_30);
        ann.talk(`No comment.`);
        ann.talk(`Is that something girls usually do?`);
        mc.talk(`Of course, I know for a fact Vanessa does.`);
        ann.talk(`Yeah... But she is not your typical girl.`);
        mc.talk(`True.`);
    } else {
        ann.talk(`You know...`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_31);
        ann.talk(`Ever since the first time, I've started to crave it...`);
        ann.talk(`Vanessa told me that would happen, but I didn't believe it at the time.`);
        mc.talk(`We can go again if you want.`);
        ImageClass.setImage(images.v7.V7AnnMCRoom_30);
        ann.talk(`What?! No way you have the energy to go again!`);
        mc.talk(`Wanna bet?`);
        ann.talk(`Hehe, maybe later then.`);
    }

    await endReplay(replayScenesList.v7AnnPrePhotoshootSex);

    mc.talk(`Are you ready to take some pictures?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_30);
    ann.talk(`Yeah but let me just get dressed.`);
    return jump(V7AnnAtMCRoom_PhotoShoot, "V7AnnAtMCRoom_PhotoShoot");
};

export const V7AnnAtMCRoom2_Question_Touch_Question_LetGo = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_9);
    mc.talk(`I would have fucked you right here and now, but we have pictures to take.`);
    ann.talk(`Yeah, yeah. Right.`);
    await endReplay();
    return jump(V7AnnAtMCRoom_PhotoShoot, "V7AnnAtMCRoom_PhotoShoot");
};

export const V7AnnAtMCRoom_PhotoShoot = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_21, { transition: true });

    ann.talk(`So how are we gonna do this?`);
    mc.talk(`What do you have in mind?`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_22);
    ann.talk(`I don't know. I've never done anything like this, I need you to tell me what to do.`);
    mc.talk(`Alright. Hmm...`);
    mc.talk(`Let's start by having you sit on my bed.`);
    ann.talk(`Ok!`);

    ImageClass.setImage(annImages.Ann8, { duration: 0.6, transition: true });
    ann.talk(`How's that?`);
    mc.talk(`It's fine for a first photo.`);

    doTakePhoto();
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann8.key);
    });
    ImageClass.setImage(annImages.Ann8);

    mc.talk(`Done.`);
    mc.talk(`Ok. Now let's try something sexier.`);
    ann.talk(`Like what?`);
    mc.talk(`Try to lay down on the bed. Like you are tanning on the beach.`);
    ann.talk(`Ok, let me try.`);
    ImageClass.setImage(annImages.Ann9, { duration: 0.6 });
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann9.key);
    });
    ann.talk(`Like this?`);
    mc.talk(`Yes, this is perfect.`);
    ann.talk(`I hope it looks good.`);
    mc.talk(`It does.`);
    doTakePhoto();
    ImageClass.setImage(annImages.Ann9);
    mc.talk(`Ok, now just try to casually sit on the bed, like you would have been if we were just talking.`);
    ImageClass.setImage(annImages.Ann10, { duration: 0.6 });
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann10.key);
    });
    ann.talk(`Like this?`);
    mc.talk(`Yeah.`);
    ann.talk(`Do it quick! I feel like my outfit is about to burst open!`);

    doTakePhoto();
    ImageClass.setImage(annImages.Ann10);
    mc.talk(`Done.`);
    return jump(V7AnnAtMCRoom_PhotoShoot_Question, "V7AnnAtMCRoom_PhotoShoot_Question");
};

export const V7AnnAtMCRoom_PhotoShoot_Question = async (): Promise<any> => {
    doWaitImageByTime(annImages.Ann11);
    await mc.setQuestion(new Question({ text: `She wasn't wrong. Her breasts are fully exposed.\nI wonder if I should...`, options: { think: true }, key: `v7PhotoShootRoomTookPhotosOfExposedBreasts` })
        .option({ title: `Take a quick photo`, key: true })
        .option({ title: `Don't take a photo`, key: false }));


    if (Question.globalAnswers.v7PhotoShootRoomTookPhotosOfExposedBreasts) {
        return jump(V7AnnAtMCRoom_PhotoShoot_Question_TakePhoto, "V7AnnAtMCRoom_PhotoShoot_Question_TakePhoto");

    } else {
        return jump(V7AnnAtMCRoom_PhotoShoot_Question_DontTakePhoto, "V7AnnAtMCRoom_PhotoShoot_Question_DontTakePhoto");

    }

};

export const V7AnnAtMCRoom_PhotoShoot_Question_TakePhoto = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann11.key);
    });
    doTakePhoto();
    ImageClass.setImage(images.v7.V7AnnMCRoom_33);
    ann.talk(`Oh!`);
    ann.talk(`No way I'm gonna post this one!`);
    ImageClass.setImage(annImages.Ann10);
    mc.talk(`You'll get banned if you did.`);
    ann.talk(`Yeah I guess...`);
    return jump(V7AnnAtMCRoom_PhotoShoot2, "V7AnnAtMCRoom_PhotoShoot2");
};

export const V7AnnAtMCRoom_PhotoShoot_Question_DontTakePhoto = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_33);
    ann.talk(`Oopsy.`);
    ann.talk(`It got loose by mistake, hehe.`);
    ImageClass.setImage(annImages.Ann10);
    return jump(V7AnnAtMCRoom_PhotoShoot2, "V7AnnAtMCRoom_PhotoShoot2");
};

export const V7AnnAtMCRoom_PhotoShoot2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnMCRoom_27, { transition: true });
    ann.talk(`I hope those look nice.`);
    mc.talk(`They do. But I think we need a change of environment.`);
    ann.talk(`What do you have in mind?`);
    mc.talk(`We should take some photos outside.`);
    ann.talk(`I agree, let me just get dressed.`);
    mc.talk(`Why? It's not that different from what you came in.`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_28);
    ann.talk(`It is! You can see my nipples.`);
    mc.talk(`Barely.`);
    mc.talk(`You said you wanna post good photos to Insta that will get you noticed.`);
    ann.talk(`I do...`);
    ImageClass.setImage(images.v7.V7AnnMCRoom_27);
    ann.talk(`Oh! I have an idea!`);
    ann.talk(`Give me a second!`);
    doTransition(images.v7.V7AnnMCRoom_29);
    ann.talk(`Now we can go out!`);
    mc.talk(`I guess that can work.`);
    ann.talk(`Great! Let's go!`);
    return jump(V7AnnMCOutsidePhotoShoot, "V7AnnMCOutsidePhotoShoot");
};

export const V7AnnMCOutsidePhotoShoot = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_1, { transition: true, duration: 0.6 });
    ann.talk(`Thanks again for helping me.`);
    ann.talk(`I know I said it like fifty times by now, but I really appreciate it!`);
    mc.talk(`I wouldn't be a very good boyfriend if I said no.`);
    ann.talk(`Hehe.`);
    ann.talk(`Ok, so what should I do?`);
    mc.talk(`You should show off your best part.`);
    mc.talk(`And I don't mean your brain.`);
    mc.talk(`Just lean towards the fence.`);
    ann.talk(`I can do that.`);
    ImageClass.setImage(annImages.Ann12);
    ann.talk(`Like this?`);
    mc.talk(`Yes, that's perfect.`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann12.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann12);
    mc.talk(`Done.`);
    return jump(V7AnnMCOutsidePhotoShoot_Question, "V7AnnMCOutsidePhotoShoot_Question");

};

export const V7AnnMCOutsidePhotoShoot_Question = async (): Promise<any> => {
    await mc.setQuestion(new Question({ text: `Maybe I can convince her to take a photo only with the outfit I got for her...`, options: { think: true }, key: `v7PhotoShootOutsideConvincedAnnPoseWithOutfit` })
        .option({ title: `Convince her`, key: true })
        .option({ title: `Don't convince`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {
        return jump(V7AnnMCOutsidePhotoShoot_Question_Convince, "V7AnnMCOutsidePhotoShoot_Question_Convince");

    } else {
        return jump(V7AnnMCOutsidePhotoShoot_Question_SomeWhereElse, "V7AnnMCOutsidePhotoShoot_Question_SomeWhereElse");

    }
};


export const V7AnnMCOutsidePhotoShoot_Question_Convince = async (): Promise<any> => {
    ImageClass.setImage(annImages.Ann12);
    mc.talk(`Have you seen anyone else around?`);
    ImageClass.setImage(images.v7.V7AnnOutside_2);
    ann.talk(`Nope. Pretty quiet. Why do you ask?`);
    mc.talk(`Well... I think it can be a perfect opportunity to take a photo with the outfit I got for you.`);
    ann.talk(`Didn't I just do that?`);
    mc.talk(`I mean, without the clothes you have over it.`);
    ann.talk(`Oh...`);
    ImageClass.setImage(images.v7.V7AnnOutside_3);
    ann.talk(`Mmm...`);
    ann.talk(`There doesn't seem to be anyone around. But I still can't do it here... in the middle of the street.`);
    mc.talk(`I know where to go.`);
    ImageClass.setImage(images.v7.V7AnnOutside_4);
    ann.talk(`Where?`);
    mc.talk(`Follow me.`);
    ImageClass.setImage(images.v7.V7AnnOutside_5);
    mc.talk(`This is a good place.`);
    ann.talk(`Hehe, I can't believe I'm doing this.\nBut I won't lie, it's kinda exciting.`);
    ImageClass.setImage(images.v7.V7AnnOutside_6, { transition: true, duration: 0.6 });
    mc.talk(`Great! Now show me that ass!`);
    ann.talk(`Hehe.`);
    ImageClass.setImage(annImages.Ann13, { duration: 0.6 });
    ann.talk(`Like so?`);
    mc.talk(`Damn, you are so hot, I'm holding myself back.`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann13.key);
    });
    doTakePhoto();
    ImageClass.setImage(images.v7.V7AnnOutside_8, { duration: 0.6 });
    mc.think(`Someone is coming...`);

    ImageClass.setImage(images.v7.V7AnnOutside_9, { duration: 0.6 });
    stranger.talk(`Girls these days are such sluts!`, { method: `Mumbling To Himself` });
    await ann.set((properties) => {
        properties.corruption++;
    });
    ImageClass.setImage(images.v7.V7AnnOutside_10);
    ann.talk(`Oh my, did you hear him?`);
    mc.talk(`Yeah...`);
    if (Question.globalAnswers.v6ToldAnnSheLooksLikeASlut) {
        mc.talk(`Don't you remember what we talked about? That's not necessary a bad thing.`);
        ImageClass.setImage(images.v7.V7AnnOutside_11);
    } else {
        mc.talk(`That's not a bad thing.`);
        ImageClass.setImage(images.v7.V7AnnOutside_11);
        ann.talk(`It's not? It sounded bad...`);
    }

    mc.talk(`He just said that because he thinks you are hot. If you were ugly he wouldn't have noticed you at all.`);
    ann.talk(`Oh... I guess that makes sense.`);
    mc.think(`Sheltered life indeed.`);

    return jump(V7AnnMCOutsidePhotoShoot_Question_SomeWhereElse, "V7AnnMCOutsidePhotoShoot_Question_SomeWhereElse");
};

export const V7AnnMCOutsidePhotoShoot_Question_SomeWhereElse = async (): Promise<any> => {
    if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {

        ImageClass.setImage(images.v7.V7AnnOutside_11);
    } else {

        ImageClass.setImage(images.v7.V7AnnOutside_1);
    }
    ann.talk(`Ok, so now what? Are we done, or should we continue?`);
    mc.talk(`We should go to the city, maybe we'll find some good spots for more shots. Mix it up a bit.`);
    if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {

        ImageClass.setImage(images.v7.V7AnnOutside_11.partials.V7AnnOutside_11_2_p);
    }
    ann.talk(`Oh! I know just the place!`);
    mc.talk(`Great, let's go.`);
    return jump(V7AnnMCCityPhotoShoot, "V7AnnMCCityPhotoShoot");
};

export const V7AnnMCCityPhotoShoot = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_12, { transition: true, duration: 0.6 });
    ann.talk(`Here we are.`);
    mc.talk(`It's not far from the bar.`);
    ann.talk(`Exactly! On my way home from there I saw some cool graffiti around this place. I think it can be a nice background, don't you think?`);
    mc.talk(`That can work.`);
    mc.talk(`I can see one behind you.`);
    ImageClass.setImage(images.v7.V7AnnOutside_13, { duration: 0.6 });
    ann.talk(`Yeah! I see it.`);
    ImageClass.setImage(images.v7.V7AnnOutside_14);
    mc.talk(`Let's get closer.`);
    return jump(V7AnnMCCityPhotoShoot2, "V7AnnMCCityPhotoShoot2");
};

export const V7AnnMCCityPhotoShoot2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_15);
    ann.talk(`There are people around, I hope they won't make fun of me.`);
    mc.talk(`They won't.`);
    ann.talk(`I hope so!`);
    ImageClass.setImage(images.v7.V7AnnOutside_16);

    ann.talk(`So? What do you think? Doesn't it look nice?`);
    mc.talk(`Yeah! It kinda does.`);
    mc.talk(`Let's take some pics.`);
    mc.talk(`Strike a pose for me.`);
    ImageClass.setImage(annImages.Ann14);
    ann.talk(`Like so?`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann14.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann14);
    mc.talk(`It's nice.`);
    if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {
        mc.talk(`But don't forget what we've talked about.`);
        ann.talk(`Yeah, yeah, hehe.`);
    } else {
        mc.talk(`If you wanna get the most of it you should show me some of that ass.`);
        ann.talk(`Ok!`);
    }
    ImageClass.setImage(annImages.Ann15, { duration: 0.6 });
    ann.talk(`How's this?`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann15.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann15);
    mc.talk(`Perfect!`);
    if (Question.globalAnswers.v1EnableNTR) {

        return jump(V7AnnMCCityPhotoShoot2Players, "V7AnnMCCityPhotoShoot2Players");
    } else {

    }
    ImageClass.setImage(annImages.Ann15);
    mc.talk(`You were right, too many people around. Let's go somewhere more quiet.`);
    ann.talk(`I agree, let's go.`);

    return jump(V7AnnMCCityPhotoShoot3, "V7AnnMCCityPhotoShoot3");
};

export const V7AnnMCCityPhotoShoot2Players = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_19);
    player1.talk(`Damnnnn girl! Gimme more of that ass!`);
    ann.talk(`Ah?`);
    return jump(V7AnnMCCityPhotoShoot2Players_Question, "V7AnnMCCityPhotoShoot2Players_Question");
};

export const V7AnnMCCityPhotoShoot2Players_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_20);
    await player1.setQuestion(new Question({ text: `Turn around! I ain't done looking.`, options: { think: false }, key: `v7PhotoShootOutsideAskedPlayersToJoin` })
        .option({ title: `Invite them to join`, key: true })
        .option({ title: `Go to another place`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideAskedPlayersToJoin) {
        return jump(V7AnnMCCityPhotoShoot2Players_Question_Invite, "V7AnnMCCityPhotoShoot2Players_Question_Invite");

    } else {
        return jump(V7AnnMCCityPhotoShoot2Players_Question_GoAway, "V7AnnMCCityPhotoShoot2Players_Question_GoAway");

    }

};

export const V7AnnMCCityPhotoShoot2Players_Question_Invite = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_21);
    mc.talk(`We are doing a photo shoot and I think you could be a great addition.`);
    mc.talk(`Why don't you join us?`);
    player1.talk(`Shit. You don't need to ask us twice.`);
    ImageClass.setImage({ ...images.v7.V7AnnOutside_16, partialsToDisplay: [images.v7.V7AnnOutside_16.partials.V7AnnOutside_16_2_p] });
    ann.talk(`Are you sure about this?`);
    mc.talk(`Why not? It can give an impression that you are already very popular.`);
    ann.talk(`Mmm... Yeah, hehe I guess you are right.`);
    mc.talk(`Well. They are coming, just smile.`);
    ImageClass.setImage(images.v7.V7AnnOutside_23);
    player1.talk(`Alright cameraman, where do you want us?`);
    mc.talk(`Just stand beside her so I can take a quick photo.`);
    ImageClass.setImage(annImages.Ann16, { duration: 0.6, transition: true });
    mc.talk(`That's good.`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann16.key);
    });
    return jump(V7AnnMCCityPhotoShoot2Players_Question_Invite_Question, "V7AnnMCCityPhotoShoot2Players_Question_Invite_Question");
};

export const V7AnnMCCityPhotoShoot2Players_Question_Invite_Question = async (): Promise<any> => {
    doTakePhoto();
    ImageClass.setImage(annImages.Ann16);
    await mc.setQuestion(new Question({ text: `Done.`, options: { think: false }, key: `v7PhotoShootOutsideTookAnotherPhotoWithPlayers` })
        .option({ title: `Take another photo`, key: true })
        .option({ title: `We're done`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideTookAnotherPhotoWithPlayers) {
        return jump(V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Another, "V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Another");

    } else {
        return jump(V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish, "V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish");

    }
};

export const V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Another = async (): Promise<any> => {
    ImageClass.setImage(annImages.Ann16, { duration: 0.6 });
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.talk(`Let's try a different pose.`);
    player1.talk(`I know exactly what you need.`);

    ImageClass.setImage(images.v7.V7AnnOutside_25, { duration: 0.6 });
    player1.talk(`Sit.`);
    ImageClass.setImage(images.v7.V7AnnOutside_26, { duration: 0.6 });
    ann.talk(`Ah...`);
    mc.talk(`It's fine go ahead.`);
    ann.talk(`Ok, hehe.`);
    ImageClass.setImage(annImages.Ann17);
    player1.talk(`You can take your time.`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann17.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann17);
    mc.talk(`Great.`);
    return jump(V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish, "V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish");
};

export const V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish = async (): Promise<any> => {
    if (Question.globalAnswers.v7PhotoShootOutsideTookAnotherPhotoWithPlayers) {

        ImageClass.setImage(annImages.Ann17);
    } else {
        ImageClass.setImage(annImages.Ann16, { duration: 0.6, transition: true });
    }

    mc.talk(`Thanks guys, this will do.`);
    player1.talk(`That's it?`);
    player1.talk(`We should move this party to my crib.`);
    mc.talk(`Maybe next time.`);
    if (Question.globalAnswers.v7PhotoShootOutsideTookAnotherPhotoWithPlayers) {

        ImageClass.setImage(images.v7.V7AnnOutside_28);
    } else {
        ImageClass.setImage(images.v7.V7AnnOutside_27);
    }
    player1.talk(`What about you hottie?`);
    ann.talk(`Ah... Maybe next time.`);
    player1.talk(`You know where to find me.`);
    ImageClass.setImage(images.v7.V7AnnOutside_30, { transition: true, duration: 0.6 });
    ann.talk(`I didn't expect that...`);
    mc.talk(`Didn't you enjoy it?`);
    ImageClass.setImage(images.v7.V7AnnOutside_31);
    ann.talk(`Well... Hehe. I can't lie, I'm really starting to love all this attention.`);
    mc.talk(`I can see that.`);
    return jump(V7AnnMCCityPhotoShoot3, "V7AnnMCCityPhotoShoot3");
};

export const V7AnnMCCityPhotoShoot2Players_Question_GoAway = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_30, { transition: true, duration: 0.6 });
    ann.talk(`Damn... I really liked that place. Too bad they disturbed us.`);
    mc.talk(`I agree... They seemed fishy; felt like we should found a new place.`);
    ann.talk(`Yeah, that was a smart idea. They seemed like trouble.`);
    return jump(V7AnnMCCityPhotoShoot3, "V7AnnMCCityPhotoShoot3");
};

export const V7AnnMCCityPhotoShoot3 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_31);
    if (Question.globalAnswers.v1EnableNTR) {
        if (Question.globalAnswers.v7PhotoShootOutsideConvincedAnnPoseWithOutfit) {
            ann.talk(`Anyway, I kinda lost track of how many photos you took. Is that enough?`);
            mc.talk(`I took a few, but I don't think we are done just yet.`);
            mc.talk(`We haven't managed to get the most out of the outfit I got for you.`);
            ImageClass.setImage(images.v7.V7AnnOutside_30);
            ann.talk(`But someone already caught me wearing it! I don't think I'm ready just yet.`);
        } else {
            mc.talk(`We barely got some pics with the outfit I got for you!`);
            ann.talk(`We did... At your place.`);
            mc.talk(`That's not enough.`);
            ann.talk(`Do you think it's a good idea to wear it in public? People might see me...`);
        }

    } else {
        mc.talk(`This place seems like a good spot.`);
        ann.talk(`You think? Where?`);
        mc.talk(`I bet we can find something if we look hard enough.`);
        ann.talk(`You can just take some photos right here and be done with it.`);
        mc.talk(`Nah, no way. I need more picture with the sexy outfit I got for you.`);
        ann.talk(`Hehe, I think we've made the most of it already.`);
    }

    if (mc.properties.alpha >= 8) {
        mc.talk(`No arguing! We are gonna do it.`);
        ImageClass.setImage(images.v7.V7AnnOutside_30);
        ann.talk(`Ah... If you say so.`);
    } else {
        mc.talk(`It's not a smart idea to stop just yet.`);
        mc.talk(`The first photos on Insta set the tone and are really important to gain followers right off the bat.`);
        ann.talk(`I can agree with the logic...`);
    }

    mc.talk(`We just need to find a good spot.`);
    ImageClass.setImage(images.v7.V7AnnOutside_32);
    ann.talk(`Wait... What about here? It seems pretty isolated.`);
    ImageClass.setImage(images.v7.V7AnnOutside_33);
    ann.talk(`And I see some cool graffiti on the walls.`);
    mc.talk(`Interesting. Let's go take a look.`);
    return jump(V7AnnMCAlleyPhotoShoot4, "V7AnnMCAlleyPhotoShoot4");
};

export const V7AnnMCAlleyPhotoShoot4 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_34, { transition: true });
    ann.talk(`Kinda creepy.`);
    ImageClass.setImage(images.v7.V7AnnOutside_35);
    ann.talk(`But I have you to protect me if something happens!`);
    mc.talk(`Of course.`);
    ann.talk(`Alright, let's take some pictures!`);
    mc.talk(`Stand next to the graffiti you like.`);
    ann.talk(`Hehe, it's obviously not gonna be the scary skull.`);
    ImageClass.setImage(images.v7.V7AnnOutside_36, { transition: true, duration: 0.6 });
    ann.talk(`Ready?`);
    mc.talk(`Yeah.`);
    if (Question.globalAnswers.v1EnableNTR) {

        empty.think(`*Snoring sound*`);
        mc.think(`Huh?`);
        ImageClass.setImage(images.v7.V7AnnOutside_37);
        if (mc.properties.joeStatus === "enemy") {
            mc.think(`Isn't that the hobo that was outside the bar after Joe's birthday party?`);

        } else {
            mc.think(`Isn't that the hobo that was outside the bar during Joey's birthday?`);

        }
        mc.think(`Anyway... He is wasted, I better just keep taking photos of Ann.`);

    } else {

    }

    ImageClass.setImage(annImages.Ann18);
    ann.talk(`What do you think of this pose?`);
    if (Question.globalAnswers.v1EnableNTR) {

        mc.think(`She isn't aware of him at all...`);
    }
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann18.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann18);
    mc.talk(`Got it!`);

    if (Question.globalAnswers.v1EnableNTR) {

        return jump(V7AnnMCAlleyPhotoShoot4_Question, "V7AnnMCAlleyPhotoShoot4_Question");
    }
    return jump(V7AnnMCAlleyPhotoShoot4_Question_Pose, "V7AnnMCAlleyPhotoShoot4_Question_Pose");
};

export const V7AnnMCAlleyPhotoShoot4_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_39);
    await mc.setQuestion(new Question({ text: `Look who woke up... I can let him enjoy the view or just leave.`, options: { think: false }, key: `v7PhotoShootOutsideLetAnnPoseInFrontHobo` })
        .option({ title: `I changed my mind, let's go`, key: false })
        .option({ title: `Let her pose`, key: true }));


    if (Question.globalAnswers.v7PhotoShootOutsideLetAnnPoseInFrontHobo) {
        return jump(V7AnnMCAlleyPhotoShoot4_Question_Pose, "V7AnnMCAlleyPhotoShoot4_Question_Pose");

    } else {
        return jump(V7AnnMCAlleyPhotoShoot4_Question_LetsGo, "V7AnnMCAlleyPhotoShoot4_Question_LetsGo");

    }
};


export const V7AnnMCAlleyPhotoShoot4_Question_LetsGo = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_39);
    mc.talk(`I changed my mind, let's go.`);
    ann.talk(`That's it? Do you think it will be enough?`);
    mc.talk(`I do.`);
    ann.talk(`Ok, let's go.`);
    return jump(V7AnnMCAlleyPhotoShoot5_Question_Home, "V7AnnMCAlleyPhotoShoot5_Question_Home");
};

export const V7AnnMCAlleyPhotoShoot4_Question_Pose = async (): Promise<any> => {
    ImageClass.setImage(annImages.Ann18);
    await ann.set((properties) => {
        properties.corruption++;
    });

    ann.talk(`Ok, I'm gonna wear just the outfit now.`);
    mc.talk(`That's what I was waiting for.`);

    ImageClass.setImage(annImages.Ann19, { duration: 0.6, transition: true });
    ann.talk(`Is this good?`);

    mc.talk(`That's amazing.`);
    ann.talk(`Hehe, you said that it's my best side.`);
    mc.talk(`It is.`);
    await mc.set((properties) => {
        properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann19.key);
    });
    doTakePhoto();
    ImageClass.setImage(annImages.Ann19);
    mc.talk(`Done.`);
    if (Question.globalAnswers.v1EnableNTR) {

        ImageClass.setImage(images.v7.V7AnnOutside_41);
        mc.talk(`The hobo isn't complaining, that's for sure.`);
    }
    ImageClass.setImage(annImages.Ann19);
    ann.talk(`And what about...`);
    ImageClass.setImage(annImages.Ann20);
    ann.talk(`This?`);
    mc.talk(`This one will definitely do the trick.`);
    if (Question.globalAnswers.v1EnableNTR) {

        ImageClass.setImage(images.v7.V7AnnOutside_44);
        hobo.talk(`Oh...`);

        ImageClass.setImage(images.v7.V7AnnOutside_45);
        hobo.talk(`AHHHH!`);
        ann.talk(`Ah?`);
        ImageClass.setImage(images.v7.V7AnnOutside_46);
        ann.talk(`Oh my!`);
        ann.talk(`Wait, I remember you! You are that pervert from outside the bar!`);
        ImageClass.setImage(images.v7.V7AnnOutside_48);
        ann.talk(`Is he dead?`);
        mc.talk(`Haha, no, he passed out. Makes sense... I bet he is drunk as fuck.`);
        return jump(V7AnnMCAlleyPhotoShoot4_Question_Pose_Question, "V7AnnMCAlleyPhotoShoot4_Question_Pose_Question");
    } else {
        await mc.set((properties) => {
            properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann20.key);
        });
        doTakePhoto();
        ImageClass.setImage(annImages.Ann20);
        mc.talk(`Done.`);
    }


    return jump(V7AnnMCAlleyPhotoShoot5, "V7AnnMCAlleyPhotoShoot5");
};


export const V7AnnMCAlleyPhotoShoot4_Question_Pose_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_47);
    await ann.setQuestion(new Question({ text: `Did you see him standing there?`, options: { think: false }, key: `v7PhotoShootOutsideSaidHeSawHobo` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideSaidHeSawHobo) {
        await mc.set((properties) => {
            properties.liar--;
        });
        mc.talk(`I did.`);
        ann.talk(`Oh... Why didn't you say anything?`);
        mc.talk(`He is harmless.`);
        ann.talk(`I guess...`);
    } else {
        await mc.set((properties) => {
            properties.liar++;
        });
        mc.talk(`No, I didn't.`);
        ann.talk(`Yeah, that's what I thought...`);
    }
    return jump(V7AnnMCAlleyPhotoShoot5, "V7AnnMCAlleyPhotoShoot5");
};

export const V7AnnMCAlleyPhotoShoot5 = async (): Promise<any> => {
    if (Question.globalAnswers.v7PhotoShootOutsideLetAnnPoseInFrontHobo != undefined) {
        ImageClass.setImage(images.v7.V7AnnOutside_47);
        mc.talk(`Anyway, I didn't manage to take a shot of your last pose.`);
        ann.talk(`Are you sure? He might...`);
        mc.talk(`Forget about him, just do it.`);
        ann.talk(`Ok.`);
        ImageClass.setImage(annImages.Ann20);
        await mc.set((properties) => {
            properties.v7AnnCorruptedPhotosTaken.push(annImages.Ann20.key);
        });
        doTakePhoto();
        ImageClass.setImage(annImages.Ann20);
        mc.talk(`Done.`);
    } else {
        ImageClass.setImage(annImages.Ann20);
        ann.talk(`I hope these will help get me famous!`);
        mc.talk(`I don't see a reason why they won't; you are hot.`);
    }

    return jump(V7AnnMCAlleyPhotoShoot5_Question, "V7AnnMCAlleyPhotoShoot5_Question");


};

export const V7AnnMCAlleyPhotoShoot5_Question = async (): Promise<any> => {
    ImageClass.setImage(annImages.Ann20);
    await ann.setQuestion(new Question({ text: `Hehe.`, options: { think: false }, key: `v7PhotoShootOutsideToldAnnYouWantToFuck` })
        .option({ title: `Tell her you wanna fuck her`, key: true })
        .option({ title: `Go home`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideToldAnnYouWantToFuck) {

        return jump(V7AnnMCAlleyPhotoShoot5_Question_Fuck, "V7AnnMCAlleyPhotoShoot5_Question_Fuck");
    } else {

        return jump(V7AnnMCAlleyPhotoShoot5_Question_Home, "V7AnnMCAlleyPhotoShoot5_Question_Home");
    }

};

export const V7AnnMCAlleyPhotoShoot5_Question_Fuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnOutside_49);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.think(`Hmmm. I wonder if Ann is feeling what I'm feeling?`);
    mc.talk(`You know, you really turned me on today.`);
    ann.talk(`Did I?`);
    mc.talk(`Of course. You look so sexy in that outfit. I'm glad I got it for you.`);
    ImageClass.setImage(images.v7.V7AnnOutside_50);
    ann.talk(`Are you really gonna...? Right here?`);
    mc.talk(`Yes.`);
    if (Question.globalAnswers.v7PhotoShootRoomFuckedAnn) {
        ann.talk(`But we already did... Back at your place.`);
        if (mc.properties.alpha >= 8) {
            mc.talk(`Quiet! Bend over.`);
            ann.talk(`Oh...`);

        } else {
            mc.talk(`So? It's been a while.`);
            mc.talk(`And I want to be inside you again.`);
            mc.think(`This girl is intoxicating.`);
        }
    } else {
        mc.talk(`I want to be inside you right now... I can't wait any longer.`);
    }

    if (Question.globalAnswers.v1EnableNTR) {

        ann.talk(`What about the homeless guy?`);
        mc.talk(`Fuck him, he is wasted.`);
        if (Game.seenScenarios.includes(`V7AnnMCCityPhotoShoot2Players_Question_Invite_Question_Finish`)) {
            mc.talk(`But even if he wasn't, didn't you say you liked the attention?`);
            ann.talk(`Hmmm... Yeah I did...`);
        }
    } else {

    }
    ImageClass.setImage(images.v7.V7AnnOutside_51);
    ann.talk(`Oh!`);
    mc.talk(`Fuck, you are so wet already.`);
    empty.think(`Sqqquaarp.`);
    ImageClass.setImage(images.v7.V7AnnOutside_52);
    ann.talk(`Ahhh... I could see what you wanted all day... Mmmmmhhh.`);
    ImageClass.setImage(images.v7.V7AnnOutside_51);
    mc.think(`Ugh... I'm not going to last long. This is too much!`);
    ImageClass.setImage(images.v7.V7AnnOutside_52);
    empty.think(`Spluuurp.`);
    mc.talk(`Auugghh!`);
    ImageClass.setImage(images.v7.V7AnnOutside_51);
    ann.talk(`Ah....`);
    mc.talk(`Aaarrgg!!`);
    ImageClass.setImage(images.v7.V7AnnOutside_53);
    mc.think(`Damn. She was right. I was so turned on seeing her pose all day that I came so quickly.`);

    ImageClass.setImage(images.v7.V7AnnOutside_54);
    ann.talk(`Oh... Wow. That was fast.`);
    mc.talk(`I told you I was horny.`);
    ann.talk(`I can't believe we just did it in public.`);
    mc.talk(`Have you lost your memory? Yesterday you were completely nude, and in front of people.`);
    ann.talk(`Yeah. I'll explain once we get home.`);
    mc.talk(`Alright, let's go.`);
    await endReplay(replayScenesList.v7AnnPhotoshootAlleySex);
    mc.think(`Ann put on the rest of her clothes, making no mention of my cum still inside her as we headed home.`);
    return jump(V7AnnMCAlleyPhotoShoot5_Question_Home, "V7AnnMCAlleyPhotoShoot5_Question_Home");
};

export const V7AnnMCAlleyPhotoShoot5_Question_Home = async (): Promise<any> => {

    if (Question.globalAnswers.v7PhotoShootOutsideToldAnnYouWantToFuck === false) {
        ImageClass.setImage(annImages.Ann20);
        mc.talk(`Ok, that's enough.`);
        ImageClass.setImage(images.v7.V7AnnOutside_54);
        ann.talk(`That was quick.`);
        mc.talk(`You are a natural, what can I say?`);
        ann.talk(`Hehe.`);
        mc.talk(`Ready to head home?`);
        ann.talk(`Yes, let's go.`);
    }
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1, { transition: true });
    ann.talk(`You really went above and beyond! I thought you would just take a few pics of me in your room and that's it.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P);
    mc.talk(`No way! I want the best for you.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ann.talk(`I saw! Hehe.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P);
    ann.talk(`Anyway, I promised that we'd talk about yesterday.`);
    if (Question.globalAnswers.v6UnderPassTakeYourClothesOff) {
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
        ann.talk(`I allowed myself to think that you had fun.`);
        mc.talk(`Why is that?`);
        ann.talk(`Because you took off your clothes like the rest of us! Of course!`);
        mc.talk(`Yeah, that makes sense.`);
    } else {
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_3);
        ann.talk(`I allowed myself to think that you didn't have fun.`);
        mc.talk(`Why is that?`);
        ann.talk(`Because you didn't take off your clothes like the rest of us?`);
        mc.talk(`I was good with watching.`);
        ann.talk(`Oh, ok. Hehe.`);
    }
    return jump(V7AnnMCAlleyPhotoShoot5_Question_Home2, "V7AnnMCAlleyPhotoShoot5_Question_Home2");
};

export const V7AnnMCAlleyPhotoShoot5_Question_Home2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ann.talk(`I had a lot of fun...`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P);
    ann.talk(`Mainly it was because I took that pill... which I'm glad I did.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ann.talk(`I don't think things would've been that wild if I haven't.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_3);
    ann.talk(`The pill just lets me do what I want without thinking.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_3.partials.V7AnnHouseAfterPhotoshoot_4_p);
    ann.talk(`And yes, I know it's something I shouldn't be doing, but I love the feeling so much.`);
    ann.talk(`Sadly, Vanessa told me she can't spare any more of them. I don't know why yet... She haven't told me.`);
    ann.talk(`I guess I have to talk to her about it later.`);
    mc.think(`Maybe I should talk to Vanessa as well.`);
    if (Question.globalAnswers.todAnnAsksWhyKissJoe === "IlikeSeeingYouWithOthers") {
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_3);
        ann.talk(`And today for example. Remember the guys that were playing basketball?`);
        mc.talk(`Yeah.`);
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_3.partials.V7AnnHouseAfterPhotoshoot_4_p);
        ann.talk(`I loved it that they joined, because I knew you'd like it.`);
        mc.talk(`Why did you think I'd like it?`);
        ann.talk(`You told me. Don't you remember? When we just met, during the truth or dare game. You told me to kiss Joe and you said you did it because you like to watch me with other people.`);
        mc.talk(`Oh, yeah. I almost forgot about that.`);
    }
    mc.talk(`So, when you take it, do you remember everything?`);
    ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_1, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P] });
    ann.talk(`Of course!`);
    ann.talk(`That's just my inner self doing what I wanna do!`);
    mc.talk(`So you are a wild girl deep down?`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ann.talk(`No comment! Hehe.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P);
    ann.talk(`Anyway, I'm glad I told you.`);
    mc.talk(`Me too.`);
    return jump(V7AnnMcPickingPhotos, "V7AnnMcPickingPhotos");
};

export const V7AnnMcPickingPhotos = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_1, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_1.partials.V7AnnHouseAfterPhotoshoot_2_P] });
    mc.talk(`Are you ready to choose what pictures to post?`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_1);
    ann.talk(`Of course!`);
    mc.talk(`Let's just go over them one by one and tell me which ones to post and which ones to pass on.`);
    ann.talk(`Alright!`);
    mc.talk(`We need to go over all of them! I didn't take them for nothing.`);
    ann.talk(`Hehe, of course! I wanna see all of them.`);
    await mc.set((properties) => {
        // in case a bug has occur and an imaged was inserted twice
        properties.v7AnnCorruptedPhotosTaken = properties.v7AnnCorruptedPhotosTaken.filter((item, i) => (properties.v7AnnCorruptedPhotosTaken.indexOf(item) == i));
        // properties.v7AnnCorruptedPhotosTaken = properties.v7AnnCorruptedPhotosTaken.filter((item, i) => i < 2);
    });
    return jump(v7AnnPhotoshootPickingPics, "v7AnnPhotoshootPickingPics");

};

export const v7AnnPhotoshootPickingPics = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_0);
    if (!Game.seenScenarios.includes(`v7AnnPhotoshootPickingPics`)) {
        await empty.set((properties) => {
            properties.tempArr = [];
        });
        await empty.set((properties) => {
            properties.counter = 0;
        });

    }
    else {

    }
    const image = mc.properties.v7AnnCorruptedPhotosTaken[empty.properties.counter || 0];

    const phoneBtn = await Phone.open(ImageClass._globalImages.get(mc.properties.v7AnnCorruptedPhotosTaken[empty.properties.counter || 0]), async () => {


        let buttonList = Object.values(PHONE_BUTTONS).filter(btn => btn !== PHONE_BUTTONS.EXIT);
        if (ann.properties.v7PhotoShootPhotosMCDenied.concat(ann.properties.v7PhotoShootPhotosMCPicked).filter(img => img === image).length > 0) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.THUMBS_DOWN && btn !== PHONE_BUTTONS.THUMBS_UP);
        }
        // most left image
        if (empty.properties.counter === 0) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.LEFT);

        }
        // most right image
        if (empty.properties.counter == mc.properties.v7AnnCorruptedPhotosTaken.length - 1) {
            buttonList = buttonList.filter(btn => btn !== PHONE_BUTTONS.RIGHT);

        }


        Phone.setButtons(buttonList);


    }, { style: PhoneStyle.INSTA });


    if (phoneBtn === PHONE_BUTTONS.RIGHT) {
        await empty.set((properties) => {
            if (properties.counter! < mc.properties.v7AnnCorruptedPhotosTaken.length - 1)
                properties.counter!++;
        });
    } else if (phoneBtn === PHONE_BUTTONS.LEFT) {
        await empty.set((properties) => {
            if (properties.counter! > 0) {
                properties.counter!--;
            }
        });
    } else if (phoneBtn === PHONE_BUTTONS.THUMBS_DOWN) {
        Phone.setButtons([]);
        await v7photoshootComments(image, false);
        await empty.set((properties) => {
            if (properties.counter! < mc.properties.v7AnnCorruptedPhotosTaken.length - 1)
                properties.counter!++;
        });

    } else if (phoneBtn === PHONE_BUTTONS.THUMBS_UP) {
        Phone.setButtons([]);
        await v7photoshootComments(image, true);
        await empty.set((properties) => {
            if (properties.counter! < mc.properties.v7AnnCorruptedPhotosTaken.length - 1)
                properties.counter!++;
        });
    }
    if (ann.properties.v7PhotoShootPhotosMCDenied.concat(ann.properties.v7PhotoShootPhotosMCPicked).length === mc.properties.v7AnnCorruptedPhotosTaken.length) {
        Phone.close(true);
        return jump(V7AnnMcPickingPhotosFinished, "V7AnnMcPickingPhotosFinished");
    }



    return jump(v7AnnPhotoshootPickingPics, "v7AnnPhotoshootPickingPics");
};

const v7photoshootComments = async (imageKey: string, toPost: boolean) => {

    switch (imageKey) {
        case annImages.Ann8.key:
            if (toPost) {
                Phone.talk({ character: ann.character, text: `You chose the first one we took!` });
                Phone.talk({ character: mc.character, text: `Of course, why not? It looks good.` });
            } else {
                Phone.talk({ character: ann.character, text: `Really? I think it's kinda cute.` });
                Phone.talk({ character: mc.character, text: `You have better pictures.` });
                Phone.talk({ character: ann.character, text: `If you say so, I trust you.` });
            }
            break;
        case annImages.Ann9.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Really? I can't believe how revealing that is.` });
                Phone.talk({ character: mc.character, text: `Just trust me.` });
                Phone.talk({ character: ann.character, text: `I do.` });
            } else {

                Phone.talk({ character: ann.character, text: `I agree. It's too much.` });
            }
            break;
        case annImages.Ann10.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Even though it's way too revealing I really like this one, it's kinda cute.` });
                Phone.talk({ character: mc.character, text: `Me too, that's why I chose it.` });
            } else {

                Phone.talk({ character: ann.character, text: `My outfit almost bursted open here so yeah let's not include that one!` });
            }
            break;
        case annImages.Ann11.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `No no no! No way I'm uploading that.` });
                Phone.talk({ character: ann.character, text: `I can't believe you acutally saved it! I thought you deleted it.` });
                Phone.talk({ character: mc.character, text: `I couldn't resist.` });
                Phone.talk({ character: ann.character, text: `It's for your eyes only!` });
                Phone.talk({ character: mc.character, text: `You can't blame me for trying.` });
                Phone.talk({ character: ann.character, text: `Next one!` });
            } else {

                Phone.talk({ character: ann.character, text: `Of course not! I can't believe you saved it!` });
                Phone.talk({ character: ann.character, text: `It's for your eyes only!` });
                Phone.talk({ character: mc.character, text: `Don't worry.` });
            }
            break;
        case annImages.Ann12.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Great choice! I like this one.` });
                Phone.talk({ character: mc.character, text: `That's what I thought.` });
            } else {

                Phone.talk({ character: ann.character, text: `Really? It's one of my favorites.` });
                Phone.talk({ character: mc.character, text: `I know what I'm looking for.` });
            }
            break;
        case annImages.Ann13.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `I was smiling before that rude person called me a slut...` });
                Phone.talk({ character: mc.character, text: `Who cares about him? This picture should definitely be posted.` });
                Phone.talk({ character: ann.character, text: `Hehe.` });
            } else {

                Phone.talk({ character: ann.character, text: `Weird, I was sure you'd choose to post this one.` });
            }
            break;
        case annImages.Ann14.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Oh, wow! I like this one! I didn't realize how good it looked when you took it.` });
                Phone.talk({ character: mc.character, text: `Are you complimenting me or yourself?` });
                Phone.talk({ character: ann.character, text: `Both? Hehe.` });
            } else {

                Phone.talk({ character: ann.character, text: `Too bad! I like this one.` });
            }
            break;
        case annImages.Ann15.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Those shorts are really SHORT.` });
                Phone.talk({ character: mc.character, text: `You should never put anything else.` });
                Phone.talk({ character: ann.character, text: `I can't believe everyone will see it.` });
                Phone.talk({ character: mc.character, text: `They see you walking down the street already.` });
                Phone.talk({ character: ann.character, text: `Yeah...` });
            } else {

                Phone.talk({ character: ann.character, text: `You said it's my best side.` });
                Phone.talk({ character: mc.character, text: `Yeah, but this one doesn't cut it.` });
            }
            break;
        case annImages.Ann16.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `I don't even know their names!` });
                Phone.talk({ character: mc.character, text: `Is that really important?` });
                Phone.talk({ character: ann.character, text: `What if someone asks?` });
                Phone.talk({ character: mc.character, text: `Just ignore.` });
            } else {

                Phone.talk({ character: ann.character, text: `Makes sense not to include it... I don't even know those guys.` });
            }
            break;
        case annImages.Ann17.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Hehe, I can't believe I sat on someone I don't know.` });
                Phone.talk({ character: mc.character, text: `Well. It looks good.` });
            } else {

                Phone.talk({ character: ann.character, text: `Hehe, I figured this one was just for the laughs and you didn't intend to post it.` });
            }
            break;
        case annImages.Ann18.key:
            if (toPost) {

                Phone.talk({ character: ann.character, text: `Oh! This one was in the alley. I like it.` });
                Phone.talk({ character: mc.character, text: `Me too.` });
            } else {

                Phone.talk({ character: ann.character, text: `Really? I think it's kinda cute.` });
                Phone.talk({ character: mc.character, text: `I'm not looking for cute.` });
            }
            break;
        case annImages.Ann19.key:
            if (toPost) {
                if (Question.globalAnswers.v1EnableNTR) {
                    Phone.talk({ character: ann.character, text: `Oh... That was before that hobo did what he did...` });
                    Phone.talk({ character: mc.character, text: `You turned him on so much he couldn't control himself.` });
                } else {
                    Phone.talk({ character: ann.character, text: `I have so many pictures like this, hehe.` });
                    Phone.talk({ character: mc.character, text: `I told you it's your best side.` });
                    Phone.talk({ character: ann.character, text: `I just hope people won't get bored of it.` });
                    Phone.talk({ character: mc.character, text: `They won't. Trust me.` });
                }
            } else {

                Phone.talk({ character: ann.character, text: `If I guessed, I would've said you'd include this one.` });
                Phone.talk({ character: mc.character, text: `Nope.` });
            }
            break;
        case annImages.Ann20.key:
            if (toPost) {
                if (Question.globalAnswers.v7PhotoShootOutsideToldAnnYouWantToFuck) {
                    Phone.talk({ character: ann.character, text: `That was just before you jumped on me.` });
                    Phone.talk({ character: mc.character, text: `Can you blame me?` });
                    Phone.talk({ character: ann.character, text: `I'm glad you did!` });
                } else {
                    Phone.talk({ character: ann.character, text: `That was the last one you took.` });
                    Phone.talk({ character: mc.character, text: `And one of the best.` });
                }
            } else {

                Phone.talk({ character: ann.character, text: `Oh... I really gave an effort here, but I can see why you wouldn't want to post it.` });
            }
            break;

        default:
            break;
    }
    if (toPost) {
        await ann.set((properties) => {
            properties.v7PhotoShootPhotosMCPicked.push(imageKey);
        });
    } else {
        await ann.set((properties) => {
            properties.v7PhotoShootPhotosMCDenied.push(imageKey);
        });

    }
    Phone.talk({ character: mc.character, text: "", options: { think: true, wait: false } });


};


export const V7AnnMcPickingPhotosFinished = async (): Promise<any> => {
    // ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5, { transition: true, duration: 0.6 });

    // if the mc choose 0 photos to post
    if (ann.properties.v7PhotoShootPhotosMCPicked.length === 0) {
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);

        ann.talk(`Really? You don't like any of my photos?`);
        mc.talk(`I did. I was the one taking them. But not enough to want to post them on Insta.`);
        ann.talk(`Oh...`);
        // if the mc picked only one photo and it's the one with her breats open
    } else if (ann.properties.v7PhotoShootPhotosMCPicked.length === 1 && ann.properties.v7PhotoShootPhotosMCPicked.includes(annImages.Ann11.key)) {
        ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_7_p] });
        ann.talk(`I should've guess that the only picture you'd chose was the one when my breasts are fully exposed...`);
        mc.talk(`Can you blame me?`);
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p);
        ann.talk(`Hehe, no... But like I said, I'm not posting it.`);
        mc.talk(`So what are you gonna do?`);
    }

    if (ann.properties.v7PhotoShootPhotosMCPicked.length === 0 || (ann.properties.v7PhotoShootPhotosMCPicked.length === 1 && ann.properties.v7PhotoShootPhotosMCPicked.includes(annImages.Ann11.key))) {
        ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p] });
        ann.talk(`Well. I'll just choose myself what to post.`);
        mc.talk(`It's your decision.`);
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
        ann.talk(`But don't think that I don't appreciate your help!`);

        // Ann is choosing the picture for herself  


        if (ann.properties.corruption > 12) {
            await ann.set((properties) => {
                properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann8.key, annImages.Ann9.key, annImages.Ann10.key);
            });
        }
        await ann.set((properties) => {
            properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann12.key);
        });
        if (ann.properties.corruption > 15) {
            await ann.set((properties) => {
                properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann13.key);
            });
        }
        await ann.set((properties) => {
            properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann14.key);
        });
        if (ann.properties.corruption > 17) {
            if (Question.globalAnswers.v1EnableNTR) {

                if (mc.properties.v7AnnCorruptedPhotosTaken.includes(annImages.Ann16.key)) {
                    await ann.set((properties) => {
                        properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann16.key);
                    });

                }
                if (mc.properties.v7AnnCorruptedPhotosTaken.includes(annImages.Ann17.key)) {
                    await ann.set((properties) => {
                        properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann17.key);
                    });

                }
            }
            await ann.set((properties) => {
                properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann18.key);
                properties.v7PhotoShootPhotosANNPicked.push(annImages.Ann20.key);
            });
        }


    } else {
        ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p] });
        ann.talk(`Well! That is it! We are done.`);
        mc.talk(`Yeah.`);
        ann.talk(`I had a really good time.`);
        mc.talk(`Me to.`);
        ann.talk(`I thought that it would bother me seeing people looking at me while posing, but it didn't.`);
        ann.talk(`I actually liked it!`);
        mc.talk(`Look at you... From a shy girl that didn't have Insta to one that is craving the spotlight.`);
        ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
        ann.talk(`What can I say, I've changed.`);
        mc.think(`For the better in my book, Sweet Ann.`);
    }


    ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p] });
    ann.talk(`I'm so excited to upload them already! I'm gonna do it as soon as I go inside!`);
    if (Question.globalAnswers.v1EnableNTR) {

        ann.talk(`I'll talk to you later or tomorrow!`);
    } else {

    }
    if (Question.globalAnswers.v1EnableNTR && Game.seenScenarios.includes(`V5AnnMovieEndChris_2_Question`)) {
        if (Question.globalAnswers.v4NoJoeyWasMeanToChris) {
            ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_7_p] });

            ann.talk(`Oh, I almost forgot to tell you.`);
            ann.talk(`I'm going with Chris to see that movie I've been talking about.`);
            ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p);
            ann.talk(`He managed to get us tickets!`);
            ann.talk(`I've asked him to get one more for you, but he couldn't manage it.`);
            ann.talk(`So yeah! I'm kinda excited to see it!`);
            mc.talk(`Well, have fun you.`);
            ann.talk(`I will! Thank you!`);
            await mc.set((properties) => {
                properties.v7AnnChrisMovieStatus = "wasntInvited";
            });
            return jump(V7AnnPhotoShootEnd, "V7AnnPhotoShootEnd");
        } else {
            ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_7_p] });
            ann.talk(`Oh! I can't believe I almost forgot to tell you!`);
            ann.talk(`Do you have plans for this evening?`);
            mc.talk(`I don't. Why?`);
            ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
            ann.talk(`Chris texted me yesterday and said he got us tickets for the movie tonight!`);
            mc.talk(`Didn't he say he only has two tickets?`);
            ann.talk(`He did, but he said he can arrange something to get you inside as well.`);
            return jump(V7AnnMcPickingPhotosFinished_Question, "V7AnnMcPickingPhotosFinished_Question");
        }
    } else {

    }

    return jump(V7AnnPhotoShootEnd, "V7AnnPhotoShootEnd");
};

export const V7AnnMcPickingPhotosFinished_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
    await ann.setQuestion(new Question({ text: `What do you say?\nWill you come to the movie with us?`, options: { think: false }, key: `v7PhotoShootOutsideAgreedGoingMoviesAnnChris` })
        .option({ title: `Sure`, key: true })
        .option({ title: `Nah, I'll pass`, key: false }));


    if (Question.globalAnswers.v7PhotoShootOutsideAgreedGoingMoviesAnnChris) {

        return jump(V7AnnMcPickingPhotosFinished_Question_Yes, "V7AnnMcPickingPhotosFinished_Question_Yes");
    } else {

        return jump(V7AnnMcPickingPhotosFinished_Question_No, "V7AnnMcPickingPhotosFinished_Question_No");
    }
};


export const V7AnnMcPickingPhotosFinished_Question_Yes = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
    mc.talk(`Sure.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p);

    ann.talk(`Yay!`);
    ann.talk(`So I'll talk to you later.`);
    return jump(V7AnnPhotoShootEnd, "V7AnnPhotoShootEnd");
};

export const V7AnnMcPickingPhotosFinished_Question_No = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_7_p] });
    await mc.set((properties) => {
        properties.v7AnnChrisMovieStatus = "refused";
    });
    mc.talk(`Nah, I'll pass.`);
    ann.talk(`Are you sure?`);
    mc.talk(`Positive.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5);
    ann.talk(`Too bad. I would have loved you to be there.`);
    ann.talk(`But I guess you already made up your mind.`);
    ImageClass.setImage(images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p);
    ann.talk(`So I'll talk to you tomorrow.`);
    return jump(V7AnnPhotoShootEnd, "V7AnnPhotoShootEnd");
};

export const V7AnnPhotoShootEnd = async (): Promise<any> => {
    // ImageClass.setImage({ ...images.v7.V7AnnHouseAfterPhotoshoot_5, partialsToDisplay: [images.v7.V7AnnHouseAfterPhotoshoot_5.partials.V7AnnHouseAfterPhotoshoot_6_p] });

    // ann.talk(`Bye ${mc.name}!`);
    // mc.talk(`Bye Ann.`);
    return jump(V7AnnPhotoShootAfter, "V7AnnPhotoShootAfter");
};


